// extracted by mini-css-extract-plugin
module.exports = {"products":"ProductsLeftyRighty-module--products--u_xxP","products__content":"ProductsLeftyRighty-module--products__content--2cIig"};